import React from 'react';

interface IconProps extends React.SVGProps<SVGSVGElement> {
	className?: string;
	variant?: 'yellow-teal' | 'teal-yellow' | 'teal-white'; // Predefined variations
	bgColor?: string; // Custom background color
	strokeColor?: string; // Custom stroke color
	fillColor?: string; // Custom fill color
}

const BundleIcon: React.FC<IconProps> = ({ className, variant, bgColor, strokeColor, fillColor, ...props }) => {
	// Predefined color mappings for variants
	const colors = {
		background: {
			'yellow-teal': '#FFF700',
			'teal-yellow': '#2C4454',
			'teal-white': '#2C4454',
		},
		stroke: {
			'yellow-teal': '#2C4454',
			'teal-yellow': '#FFF700',
			'teal-white': '#FFFFFF',
		},
		fill: {
			'yellow-teal': '#2C4454',
			'teal-yellow': '#FFF700',
			'teal-white': '#FFFFFF',
		},
	};

	// Determine colors: use custom props if provided, else use variant-based colors
	const backgroundCol = bgColor || (variant ? colors.background[variant] : '#2C4454');
	const fillCol = fillColor || (variant ? colors.fill[variant] : '#FFF700');

	return (
		<svg
			width="76px"
			height="76px"
			viewBox="0 0 76 76"
			xmlns="http://www.w3.org/2000/svg"
			className={className}
			aria-labelledby="title"
			role="img"
			{...props}
		>
			<title id="title"></title>
			{/* Background Circle */}
			<path
				d="M37.6416 75.5266C16.9365 75.5266 0.141602 58.7467 0.141602 38.0266C0.141602 17.3215 16.9215 0.526611 37.6416 0.526611C58.3468 0.526611 75.1416 17.3065 75.1416 38.0266C75.1416 58.7318 58.3618 75.5266 37.6416 75.5266Z"
				fill={backgroundCol}
			/>
			{/* Main Shape 1 */}
			<path
				d="M49.7168 54.2523V35.1651C49.7168 31.4196 46.6754 28.3783 42.9299 28.3783C39.1844 28.3783 36.1431 31.4196 36.1431 35.1651V35.7045V40.8883C36.1431 42.9858 34.4352 44.6937 32.3377 44.6937C30.2402 44.6937 28.5322 42.9858 28.5322 40.8883V34.6408C28.8019 26.94 35.1543 20.7524 42.9299 20.7524C50.7056 20.7524 57.3277 27.2097 57.3277 35.1502V54.2373H49.7168V54.2523Z"
				fill={fillCol}
			/>
			{/* Main Shape 2 */}
			<path
				d="M32.3528 55.301C24.4123 55.301 17.9551 48.8438 17.9551 40.9033V21.8162H25.566V40.9033C25.566 44.6488 28.6073 47.6901 32.3528 47.6901C36.0983 47.6901 39.1397 44.6488 39.1397 40.9033V35.1651C39.1397 33.0677 40.8476 31.3597 42.9451 31.3597C45.0426 31.3597 46.7506 33.0677 46.7506 35.1651V40.9033C46.7506 48.8438 40.2933 55.301 32.3528 55.301Z"
				fill={fillCol}
			/>
		</svg>
	);
};

export default BundleIcon;
